module.exports = function(variants = ['responsive']) {
    return function({ addUtilities }) {
        const utilities = {
            '.xy-center': {
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%,-50%)'
            },
            '.x-center': {
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)'
            },
            '.y-center': {
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        };

        addUtilities(utilities, variants);
    };
};
